import {createIcon} from "./icons.js"

function attachDialogCloseHandlerWithParent(parent, closeHandler) {

    var container = document.createElement("div")
    parent.appendChild(container)
    container.appendChild(createIcon("times"))
    container.addEventListener('click', function (e) {
        e.preventDefault()
        e.stopPropagation()
        closeHandler()
    })
}

export {attachDialogCloseHandlerWithParent}

